var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVideo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6321 0.0702638C10.6634 0 9.47618 0 8 0H7.92112L5.12111 4.20002H8.87889L11.6321 0.0702638Z",
    fill: "#06320A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47653 0.00355916C3.69755 0.0245747 2.17347 0.169679 1.17157 1.17157C0.485442 1.8577 0.201143 2.78874 0.0833438 4.20002H3.67889L6.47653 0.00355916Z",
    fill: "#06320A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0211556 5.40002C0 6.151 0 7.01061 0 8C0 11.7712 0 13.6569 1.17157 14.8284C2.34315 16 4.22876 16 8 16C11.7712 16 13.6569 16 14.8284 14.8284C16 13.6569 16 11.7712 16 8C16 7.01061 16 6.151 15.9788 5.40002H0.0211556ZM3 9.6C3 9.26863 3.26863 9 3.6 9H10C10.3314 9 10.6 9.26863 10.6 9.6C10.6 9.93137 10.3314 10.2 10 10.2H3.6C3.26863 10.2 3 9.93137 3 9.6ZM3.6 11.8C3.26863 11.8 3 12.0686 3 12.4C3 12.7314 3.26863 13 3.6 13H8C8.33137 13 8.6 12.7314 8.6 12.4C8.6 12.0686 8.33137 11.8 8 11.8H3.6Z",
    fill: "#06320A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8284 1.17157C15.5146 1.8577 15.7989 2.78874 15.9167 4.20002H10.3211L12.959 0.243222C13.7539 0.410763 14.3506 0.693714 14.8284 1.17157Z",
    fill: "#06320A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Video.c866d556.svg";
export { ForwardRef as ReactComponent };